module.exports = __webpack_public_path__ + "img/pending.77c79079.svg";